class PaginationDropdown extends HTMLElement {
  #button = this.querySelector('[data-pagination-toggle]');
  #dropdown = this.querySelector('[data-pagination-dropdown]');

  connectedCallback() {
    this.#button?.addEventListener('click', this.#toggle);
    document.addEventListener('click', this.#handleOutsideClick);
  }

  disconnectedCallback() {
    this.#button?.removeEventListener('click', this.#toggle);
    document.removeEventListener('click', this.#handleOutsideClick);
  }

  #toggle = () => {
    const isOpen = this.#dropdown.classList.toggle('hidden');
    this.#button.setAttribute('aria-expanded', !isOpen);
  };

  #handleOutsideClick = (event) => {
    if (!this.contains(event.target)) {
      this.#dropdown.classList.add('hidden');
      this.#button.setAttribute('aria-expanded', 'false');
    }
  };
}

customElements.define('pagination-dropdown', PaginationDropdown);
